import ExcelGrid from "./ExcelGrid";
import { Box, Card, CardContent } from "@mui/material";
import React, { memo } from "react";

/**
 * TablePanel Component - Left panel containing the Excel-style table grid
 * Handles responsive layout and table display
 */
const TablePanel = ({
  // Layout props
  pdfPanelExpanded,
  sidebarWidth,

  // Table data
  selectedTable,
  tableData,
  currentPage,
  setCurrentPage,
  showStats,
  setShowStats,
  showConfidence,
  setShowConfidence,
  rowIds,

  // Table zoom
  tableZoom,
  setTableZoom,

  // Confidence filtering
  confidenceFilterEnabled,
  setConfidenceFilterEnabled,
  confidenceThreshold,
  setConfidenceThreshold,

  // Cell editing
  editingCell,
  selectedCell,
  editValue,
  setEditValue,

  // Cell operations
  handleCellClick,
  startCellEdit,
  saveCellEdit,
  cancelCellEdit,
  setCellInfoAnchor,

  // Table operations
  removeColumnGlobally,
  removeRow,

  // Recovery operations
  deletedRows,
  deletedColumns,
  recoverRowById,
  recoverColumnById,
  recoverAllRows,
  recoverAllColumns,

  // Utility functions
  isMultiPageTable,
  getTablePages,
  calculateColumnStats,
}) => {
  return (
    <Box
      sx={{
        flexBasis: pdfPanelExpanded ? `${100 - sidebarWidth}%` : "100%",
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        p: 2,
        transition: pdfPanelExpanded ? "none" : "all 0.3s ease-in-out",
        minWidth: 0, // Prevent flex item from overflowing
      }}
    >
      <Card sx={{ flex: 1, overflow: "hidden" }}>
        <CardContent sx={{ height: "100%", p: 1 }}>
          <ExcelGrid
            selectedTable={selectedTable}
            tableData={tableData}
            editingCell={editingCell}
            selectedCell={selectedCell}
            editValue={editValue}
            setEditValue={setEditValue}
            saveCellEdit={saveCellEdit}
            cancelCellEdit={cancelCellEdit}
            startCellEdit={startCellEdit}
            setCellInfoAnchor={setCellInfoAnchor}
            isMultiPageTable={isMultiPageTable}
            getTablePages={getTablePages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            showStats={showStats}
            setShowStats={setShowStats}
            showConfidence={showConfidence}
            setShowConfidence={setShowConfidence}
            tableZoom={tableZoom}
            setTableZoom={setTableZoom}
            confidenceFilterEnabled={confidenceFilterEnabled}
            setConfidenceFilterEnabled={setConfidenceFilterEnabled}
            confidenceThreshold={confidenceThreshold}
            setConfidenceThreshold={setConfidenceThreshold}
            calculateColumnStats={calculateColumnStats}
            handleCellClick={handleCellClick}
            removeColumnGlobally={removeColumnGlobally}
            removeRow={removeRow}
            rowIds={rowIds}
            deletedRows={deletedRows}
            deletedColumns={deletedColumns}
            recoverRowById={recoverRowById}
            recoverColumnById={recoverColumnById}
            recoverAllRows={recoverAllRows}
            recoverAllColumns={recoverAllColumns}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default memo(TablePanel);
